import { useDoesUserExistInCurrentContext } from "core/hooks/useDoesUserExistInCurrentContext";
import { ApplicationErrorBoundaryPage } from "core/pages/ApplicationErrorBoundaryPage";
import { UnauthorizedContextPage } from "core/pages/UnauthorizedContextPage";
import type { ReactNode } from "react";
import { ApplicationLoadingDisplay } from "../ApplicationLoadingDisplay";
import { ErrorComponent } from "../ErrorComponent";
import { UnauthorizedLayout } from "../Layout/UnauthorizedLayout";

/**
 * This component is responsible for checking that the user's permission context
 * contains the application's current brand/region context
 * If the user exists, it will display the children
 * If the user does not exist, it will display the UnauthorizedContextPage
 */
export function ContextVerifier({ children }: { children: ReactNode }) {
  const { isLoading, isError, userExists } = useDoesUserExistInCurrentContext();

  if (isError) {
    return (
      <ApplicationErrorBoundaryPage>
        <ErrorComponent apiError={isError} />
      </ApplicationErrorBoundaryPage>
    );
  }
  if (isLoading) {
    return <ApplicationLoadingDisplay />;
  }
  if (!userExists) {
    return (
      <UnauthorizedLayout>
        <UnauthorizedContextPage />
      </UnauthorizedLayout>
    );
  }
  return children;
}
